import { PhotoView } from "../models/PhotoModel"

type PhotoStandardLayout = {
  mainWidthPercent: number
  subWidthPercent: number
  mainHeightPercent: number
}
function sumAspect(photos: PhotoView[]): number {
  return photos.reduce((i, p) => i + p.aspectHeight, 0)
}

function roundN(value: number, base: number = 5) {
  return Number(value.toFixed(base))
}

function photo2split(photos: PhotoView[]): [PhotoView[], PhotoView[]] {
  const times = photos.length
  let results = []
  for (let i = 1; i < times; i++) {
    const left = photos.slice(0, i)
    const right = photos.slice(i)
    const per = Math.abs(1 - sumAspect(left) / sumAspect(right))
    results.push({ left, right, per })
  }
  results = results.sort((a, b) => {
    return a.per > b.per ? 1 : -1
  })
  // console.log(results[0].per)
  return [results[0].left, results[0].right]
}

export function calcStandardThreeColumnLayout(photos: PhotoView[]) {
  // 右要素のwidthを1としたときに、メイン要素の割合を計算する
  const mainPhoto: PhotoView = photos[0]
  const [c2, c3] = photo2split(photos.slice(1))

  const c2h = c2.reduce((pv, cv) => {
    return pv + cv.aspectWidth
  }, 0.0)
  const c3h = c3.reduce((pv, cv) => {
    return pv + cv.aspectWidth
  }, 0.0)

  let c3vw
  let c2vw
  let c1vw // , vh

  if (c3h > c2h) {
    c3vw = 1
    c2vw = c3h / c2h
    // aspectHeight = 1.5; のことを確認する
    c1vw = c3h * mainPhoto.aspectHeight
  } else {
    c3vw = c2h / c3h
    c2vw = 1
    c1vw = c2h * mainPhoto.aspectHeight
  }
  const vw = c1vw + c2vw + c3vw
  const c1wPercent = roundN((c1vw / vw) * 100)
  const c2wPercent = roundN((c2vw / vw) * 100)
  const c3wPercent = 100 - c1wPercent - c2wPercent
  return {
    col1: {
      photo: mainPhoto,
      percent: c1wPercent
    },
    col2: {
      photos: c2,
      percent: c2wPercent
    },
    col3: {
      photos: c3,
      percent: c3wPercent
    }
  }
}

export function calcStandardTwoColumnLayout(
  photos: PhotoView[]
): PhotoStandardLayout {
  // 右要素のwidthを1としたときに、メイン要素の割合を計算する
  const mainPhoto: PhotoView = photos[0]
  const subPhotos: PhotoView[] = photos.slice(1)
  // 右要素の高さ比率を計算
  const height = subPhotos.reduce((pv, cv) => {
    return pv + cv.aspectWidth
  }, 0.0)
  const mainWidth = height * mainPhoto.aspectHeight
  const mainHeightPercent = Math.floor((height / mainWidth) * 100)
  const mainWidthPercent = Math.floor((mainWidth / (1 + mainWidth)) * 100)
  const subWidthPercent = 100 - mainWidthPercent
  return { mainWidthPercent, mainHeightPercent, subWidthPercent }
}
